<template>
  <div class="m-home">
    <div class="scroll home-scroll">
      <div class="hhead">
        <div class="hh-top"><span class="ttl">益体康 · 心贴智慧工作台</span></div>
        <div class="hh-hi">{{ greeting }}，{{ profile.name || '项目经理' }}</div>
      </div>

      <div class="stats">
        <div class="stats-hd"><span>今日数据</span><span class="stats-date">{{ todayStr }}</span></div>
        <div
          class="stat"
          v-for="item in overview"
          :key="item.key"
          :class="item.cls"
          @click="goOrders(item.key)"
        >
          <b>{{ item.value }}</b>
          <span>{{ item.label }}</span>
        </div>
      </div>

      <div class="panel">
        <div class="pn-hd">
          <h3>进行中的项目</h3>
          <span class="more" @click="$router.push('/m/project')">全部项目
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"
                 stroke-linejoin="round"><path d="M9 5l7 7-7 7"/></svg>
          </span>
        </div>
        <div v-if="loading" class="loading-sm">加载中…</div>
        <div v-else-if="runningProjects.length === 0" class="empty-sm">暂无进行中的项目</div>
        <div v-else>
          <div class="hp-item" v-for="p in runningProjects" :key="p.id" @click="goProjectOrders(p)">
            <span class="dot"></span>
            <span class="mid">
              <span class="nm">{{ p.name }}</span>
              <span class="dt">{{ p.startDate }} 至 {{ p.endDate }}</span>
            </span>
            <svg class="ar" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"
                 stroke-linecap="round" stroke-linejoin="round">
              <path d="M9 5l7 7-7 7"/>
            </svg>
          </div>
        </div>
      </div>
    </div>
    <m-tab-bar/>
  </div>
</template>

<script>
import MTabBar from './MTabBar.vue';
import mobileRem from '@/commonJs/mobileRem';
import ApiService from '@/service/ApiService';
import pub from '@/service/public';
import cookie from '@/service/cookie';

export default {
  name: 'MHome',
  components: {
    MTabBar
  },
  mixins: [mobileRem],
  data() {
    return {
      loading: false,
      runningProjects: [],
      todayStr: '',
      greeting: '您好',
      // 今日数据接口暂无，保留空数据占位
      stats: {all: 0, advice: 0, reject: 0},
      profile: {
        name: '',
        org: '益体康'
      }
    };
  },
  computed: {
    overview() {
      return [
        {key: 'all', label: '发单数', value: this.stats.all, cls: ''},
        {key: 'advice', label: '出建议', value: this.stats.advice, cls: 'ok'},
        {key: 'reject', label: '废单数', value: this.stats.reject, cls: 'dg'}
      ];
    }
  },
  mounted() {
    this.fetchTodayStats();
    this.loadData();
  },
  methods: {
    getGreeting() {
      const h = new Date().getHours();
      if (h >= 5 && h < 12) return '上午好';
      if (h >= 12 && h < 14) return '中午好';
      if (h < 18) return '下午好';
      return '晚上好';
    },
    // 秒级时间戳 → 'YYYY-MM-DD'
    fmtDate(ts) {
      if (!ts || ts === 0 || ts === '0') return '';
      const d = new Date(Number(ts) * 1000);
      const p = n => n < 10 ? '0' + n : '' + n;
      return [d.getFullYear(), p(d.getMonth() + 1), p(d.getDate())].join('-');
    },
    loadData() {
      const pad = n => (n < 10 ? '0' + n : '' + n);
      const d = new Date();
      this.todayStr = [d.getFullYear(), pad(d.getMonth() + 1), pad(d.getDate())].join('-');
      this.greeting = this.getGreeting();

      // 从登录态读用户姓名
      const userInfoStr = cookie.getCookie('28project_UsrInfo');
      if (userInfoStr) {
        try {
          const info = JSON.parse(userInfoStr);
          this.profile.name = info.strUsrRealName || '';
        } catch (e) { /* ignore */
        }
      }

      // 进行中项目：传参与 PC 端 Home.vue 一致，仅 agent=mobile
      this.loading = true;
      ApiService.ManagerProjectList({
        page: {number: 0, limit: 10},
        keyWord: [],
        parms: {
          status: 400 // 进行中（与 PC 端 Home 一致）
        }
      }, 'mobile').then(res => {
        this.loading = false;
        if (res && res.code === pub.backCode.SUCCESS) {
          const list = (res.data && res.data.pageList) || [];
          this.runningProjects = list.map(p => ({
            id: p.projectUuid || p.uuid || p.projectId || p.projectName,
            name: p.projectName,
            startDate: this.fmtDate(p.startTime),
            endDate: this.fmtDate(p.endTime)
          }));
        } else {
          pub.analysisReturnCode(res, null);
        }
      }).catch(err => {
        this.loading = false;
        console.error('获取进行中项目失败：', err);
      });
    },
    // 今日数据卡片：单接口请求，后端按当天时间范围返回各类型总数，前端直接展示
    fetchTodayStats() {
      if (this.statsLoading) return
      this.statsLoading = true

      // 当天 0 点的秒级时间戳（开始/结束均为当天 0 点，与 MOrder.buildTimeFrameParams 一致）
      const today0 = Math.floor(new Date(new Date().setHours(0, 0, 0, 0)).getTime() / 1000)

      const params = {
        page: {number: 0, limit: 10},
        keyWord: [],
        parms: {
          operationType: 100,
          timeFrame: [{timeType: 5, startTime: today0, endTime: today0}]
        }
      }
      
      ApiService.HeartRecordStat(params, 'mobile')
        .then(res => {
          if (res && res.code === pub.backCode.SUCCESS) {
            // 后端返回结构约定：res.data = { sendCount: 发单数, suggestedCount: 出建议数, canceledCount: 废单数 }
            const d = res.data || {}
            this.stats.all = d.sendCount || 0
            this.stats.advice = d.suggestedCount || 0
            this.stats.reject = d.canceledCount || 0
          } else {
            pub.analysisReturnCode(res, null)
          }
        })
        .catch(err => {
          console.error('获取今日数据统计失败：', err)
        })
        .finally(() => {
          this.statsLoading = false
        })
    },
    goProjectOrders(project) {
      this.$router.push({
        path: '/m/order',
        query: {
          pid: project.id,
          pname: project.name
        }
      });
    },
    goOrders(key) {
      // 首页统计卡 -> 数据列表，带入对应状态与"今日"时间筛选
      // 发单 = 全部状态；出建议 = 已出报告(400)，按报告时间；废单 = 已驳回(5000)
      const conf = {
        all:    { status: 'all',  ttype: 'entry' },
        advice: { status: '400',  ttype: 'report' },
        reject: { status: '5000', ttype: 'entry' }
      };
      const c = conf[key] || conf.all;
      this.$router.push({ path: '/m/order', query: { status: c.status, today: '1', ttype: c.ttype } });
    }
  }
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  -webkit-tap-highlight-color: transparent
}

.m-home {
  --primary: #12b3a8;
  --primary-d: #0d9b91;
  --primary-l: #e8f8f6;
  --success: #16b364;
  --success-l: #e7f8ef;
  --danger: #f5544b;
  --danger-l: #ffeeed;
  --purple: #8b5cf6;
  --purple-l: #f3edff;
  --t1: #14181f;
  --t2: #5b6472;
  --t3: #9aa4b2;
  --line: #eef0f4;
  --bg: #f4f6f8;
  --card: #fff;
  --grad: linear-gradient(135deg, #14bcb0, #0b8f89);
  font-size: 14px;
  line-height: normal;
  -webkit-text-size-adjust: 100%;
  min-height: 100vh;
  background: var(--bg);
  display: flex;
  flex-direction: column
}

.hhead {
  flex: none;
  background: var(--grad);
  color: #fff;
  padding: 6px 18px 60px
}

.hh-top {
  display: flex;
  align-items: center;
  font-size: 13px;
  opacity: .9;
  height: 28px
}

.hh-top .ttl {
  flex: 1
}

.hh-hi {
  font-size: 21px;
  font-weight: 700;
  margin-top: 10px
}

.scroll {
  flex: 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding-bottom: calc(56px + env(safe-area-inset-bottom))
}

.home-scroll {
  padding: 0 0 24px
}

.page-pad {
  padding: 0 12px 12px
}

.stats {
  margin: -44px 14px 0 14px;
  background: #fff;
  border-radius: 16px;
  padding: 10px 4px 12px;
  display: grid;
  grid-template-columns:repeat(3, 1fr);
  box-shadow: 0 6px 20px rgba(20, 24, 31, .09);
  position: relative;
  z-index: 3
}

.stats-hd {
  grid-column: 1 / -1;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2px 12px 8px;
  margin: 0 4px 2px;
  border-bottom: .5px solid var(--line);
  font-size: 12.5px;
  color: var(--t1);
  font-weight: 600
}

.stats-hd .stats-date {
  font-size: 11px;
  font-weight: 400;
  color: var(--t3);
  font-family: ui-monospace, Menlo, Consolas, monospace
}

.stat {
  text-align: center;
  padding: 8px 2px;
  border-radius: 10px;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent
}

.stat:active {
  background: var(--bg)
}

.stat b {
  display: block;
  font-size: 20px;
  font-weight: 700;
  color: var(--t1);
  line-height: 1.2
}

.stat span {
  font-size: 11.5px;
  color: var(--t3);
  margin-top: 3px;
  display: block
}

.stat.ok b {
  color: var(--success)
}

.stat.dg b {
  color: var(--danger)
}

.panel {
  margin: 14px 14px 0 14px;
  background: #fff;
  border-radius: 16px;
  padding: 14px;
  box-shadow: 0 2px 10px rgba(20, 24, 31, .05)
}

.pn-hd {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 6px
}

.pn-hd h3 {
  font-size: 15px;
  font-weight: 600;
  color: var(--t1)
}

.pn-hd .more {
  font-size: 12.5px;
  color: var(--t3);
  display: flex;
  align-items: center;
  gap: 2px;
  cursor: pointer
}

.pn-hd .more svg {
  width: 13px;
  height: 13px
}

.hp-item {
  display: flex;
  align-items: center;
  padding: 11px 0;
  border-bottom: 1px solid var(--line);
  cursor: pointer
}

.hp-item:last-child {
  border-bottom: none
}

.hp-item .dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--success);
  flex: none;
  margin-right: 9px
}

.hp-item .mid {
  flex: 1;
  min-width: 0
}

.hp-item .nm {
  display: block;
  font-size: 14px;
  color: var(--t1);
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap
}

.hp-item .dt {
  display: block;
  font-size: 11.5px;
  color: var(--t3);
  margin-top: 4px;
  font-family: ui-monospace, Menlo, Consolas, monospace
}

.hp-item .ar {
  width: 16px;
  height: 16px;
  color: #cfd5de;
  flex: none;
  margin-left: 6px
}

.skeleton {
  padding: 0
}

.sk-row {
  height: 50px;
  background: linear-gradient(90deg, #f1f3f6 25%, #eef0f4 50%, #f1f3f6 75%);
  background-size: 200% 100%;
  animation: shimmer 1.2s infinite;
  border-radius: 8px;
  margin-bottom: 10px
}

.sk-row:last-child {
  margin-bottom: 0
}

@keyframes shimmer {
  0% {
    background-position: 200% 0
  }
  100% {
    background-position: -200% 0
  }
}

.empty-sm {
  background: #fff;
  border-radius: 14px;
  padding: 30px;
  text-align: center;
  color: #8a93a6;
  font-size: 13px
}

.loading-sm {
  background: #fff;
  border-radius: 14px;
  padding: 30px;
  text-align: center;
  color: #8a93a6;
  font-size: 13px
}

/* 列表加载态 */
.m-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 90px 0;
  gap: 12px;
  color: var(--t3)
}

.m-loading .spin {
  width: 26px;
  height: 26px;
  border: 2.5px solid #d8dde5;
  border-top-color: var(--primary);
  border-radius: 50%;
  animation: spin .7s linear infinite
}

.m-loading p {
  font-size: 13px
}

@keyframes spin {
  to {
    transform: rotate(360deg)
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mobile/MHome.vue